import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ModLocServiciiService } from '../mod-loc-servicii.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { ModulLocatiiServiciiActive } from '../mod-loc-servicii.interface';
import { GhiseuModuleService } from '../../ghiseu-module/ghiseu-module.service';
import { LocatiiService } from '../../locatii/locatii.service';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';
import { ServiciiService } from '../../servicii/servicii.service';
import { CommonService } from 'src/app/services/common.service';
import { Modul } from '../../ghiseu-module/ghiseu-module.interface';

@Component({
    selector: 'app-add-mod-loc-servicii',
    templateUrl: './add-mod-loc-servicii.component.html',
    styleUrls: ['./add-mod-loc-servicii.component.scss']
})
export class AddModLocServiciiComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    module!: any[];
    locatii!: any[];
    servicii!: any[];
    users!: any[];

    form: FormGroup = new FormGroup({
        id_modul: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_locatie: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_serviciu: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        id_user: new FormControl('-1', [Validators.required, notDefaultValidator('-1')]),
        email_to_reports: new FormControl('', [Validators.required]),
    });

    durataOptions: { name: string; value: number }[] = [
        { name: '-- Alegeți --', value: -1 },
        { name: '5 minute', value: 5 },
        { name: '10 minute', value: 10 },
        { name: '15 minute', value: 15 },
        { name: '20 minute', value: 20 },
        { name: '25 minute', value: 25 },
        { name: '30 minute', value: 30 },
        { name: '35 minute', value: 35 },
        { name: '40 minute', value: 40 },
        { name: '45 minute', value: 45 },
        { name: '50 minute', value: 50 },
        { name: '55 minute', value: 55 },
        { name: '60 minute', value: 60 },
    ]

    constructor(
        private dialogRef: MatDialogRef<AddModLocServiciiComponent>,
        private moduleLocatiiServiciiActiveService: ModLocServiciiService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private ghiseuModuleService: GhiseuModuleService,
        private locatiiService: LocatiiService,
        private serviciiService: ServiciiService,
        private commonService: CommonService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.loadModule();
        this.loadLocatii();
        this.loadServicii();
        this.loadUsersGhiseu();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.moduleLocatiiServiciiActiveService.setToken(token);
        });
    }

    loadModule() {
        this.isLoading = true;
        this.ghiseuModuleService.getModule().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.module = res;
            },
            error: (err) => {
                console.error('Error in get ghiseu module: ', err);
            }
        })
    }

    loadLocatii() {
        this.isLoading = true;
        this.locatiiService.getLocatii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.locatii = res;
            },
            error: (err) => {
                console.error('Error in get locatii: ', err);
            }
        })
    }

    loadServicii() {
        this.isLoading = true;
        this.serviciiService.getServicii().pipe(
            map((results: any) => [...results.data]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.servicii = res;
            },
            error: (err) => {
                console.error('Error in get servicii: ', err);
            }
        })
    }

    loadUsersGhiseu() {
        this.isLoading = true;
        this.commonService.getUsersGhiseu().pipe(
            map((results: any) => [...results]),
            finalize(() => (this.isLoading = false))
        ).subscribe({
            next: (res) => {
                this.users = res;
            },
            error: (err) => {
                console.error('Error in get users ghiseu unic: ', err);
            }
        })
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    submitForm() {
        this.isLoading = true;

        const { id_modul, id_locatie, id_serviciu, id_user, email_to_reports } = this.form.value as ModulLocatiiServiciiActive;

        const newModulLocatiiServiciiActive: ModulLocatiiServiciiActive = {
            id_modul,
            id_locatie,
            id_serviciu,
            id_user,
            email_to_reports,
        };

        this.moduleLocatiiServiciiActiveService
            .addModulLocatiiServicii(newModulLocatiiServiciiActive)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
